import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { supabase } from '../../config/supabase';

interface CashMovement {
  id: string;
  type: 'in' | 'out';
  amount: number;
  description: string;
  payment_method: string;
  created_at: string;
}

interface CashMovementsState {
  items: CashMovement[];
  loading: boolean;
  error: string | null;
}

const initialState: CashMovementsState = {
  items: [],
  loading: false,
  error: null,
};

export const getCashMovements = createAsyncThunk(
  'cashMovements/getCashMovements',
  async () => {
    const { data, error } = await supabase
      .from('cash_movements')
      .select('*');
    
    if (error) throw error;
    return data;
  }
);

const cashMovementsSlice = createSlice({
  name: 'cashMovements',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCashMovements.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCashMovements.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(getCashMovements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Erro ao carregar movimentações de caixa';
      });
  },
});

export default cashMovementsSlice.reducer; 